import React from "react";
import {
  usePdpSellingPlan,
  usePdpVariant,
} from "./PdpContext";
import { PriceDisplay } from "@/features/product/PriceDisplay";
import { DroppsProduct, productSelect, variantSelect } from "@/store";
import { ProductCard, ProductCardValue } from "../product/ProductCard";

export const WhatsIncluded = ({
  bundledItems,
  overrideFutureShipments,
}: {
  bundledItems: DroppsProduct[];
  overrideFutureShipments?: string;
}) => {
  const variant = usePdpVariant();
  const sellingPlan = usePdpSellingPlan();

  const bundleSubVariants = bundledItems.flatMap((bundled) => {
    const variant = productSelect.defaultVariant(bundled);
    return variant.subscription === undefined
      ? []
      : [{ bundled, subscriptionPrice: variant.subscription.discount.price }];
  });

  return (
    <div className="flex w-full flex-col space-y-4">
      <ul className="flex flex-col">
        {bundledItems.map((product) => {
          const featuredImage = productSelect.featuredImage(product);
          const productCardProduct: ProductCardValue = {
            featuredImage: { ...featuredImage, src: featuredImage.url },
            size: variantSelect.sizeFormat(
              productSelect.defaultVariant(product)
            ),
            title: product.title,
            price: undefined,
          };
          return (
            <ProductCard
              className="-m-3"
              bordered={false}
              hoverable={false}
              key={product.handle}
              compact
              productCardValue={productCardProduct}
            />
          );
        })}
      </ul>
      {bundleSubVariants.length > 0 && variant.subscription && sellingPlan && (
        <>
          <div className="flex justify-between">
            <p className="body font-semibold">{"Today's Total:"}</p>
            <PriceDisplay
              standardPrice={variant.compareAtPrice ?? variant.price}
              discountPrice={variant.subscription.discount.price}
              showDiscountPrice={!!variantSelect.subscriptionDiscount(variant)}
            />
          </div>
          {overrideFutureShipments ? (
            <>
              <div className="border-0 border-t border-solid border-primary-200" />
              <p className="text-sm italic">{overrideFutureShipments}</p>
            </>
          ) : (
            <div className="bg-primary-50 p-4">
              <p className="title text-sm">
                Future Shipments
                {variant.subscription &&
                  variant.subscription.discount.kind === "percentage" &&
                  variant.subscription.discount.percentage > 0 && (
                    <> (Save {variant.subscription.discount.percentage}%)</>
                  )}
              </p>
              <div className="my-4 border-0 border-t border-solid border-primary-200" />
              {bundleSubVariants.map((bundle) => {
                const { subscriptionPrice, bundled: product } = bundle;
                const variant = productSelect.defaultVariant(product);
                const featuredImage = productSelect.featuredImage(product);
                const productCardProduct: ProductCardValue = {
                  featuredImage: { ...featuredImage, src: featuredImage.url },
                  size: sellingPlan.name,
                  title: product.title,
                  price: subscriptionPrice,
                  compareAtPrice: variant.price,
                  featuredText: variantSelect.sizeFormat(variant),
                };
                return (
                  <ProductCard
                    className="-m-4 !bg-transparent [&_.product-card-scent-name]:bg-white"
                    bordered={false}
                    hoverable={false}
                    key={product.handle}
                    compact
                    productCardValue={productCardProduct}
                  />
                );
              })}
            </div>
          )}
        </>
      )}
    </div>
  );
};
